import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-delete-batch-table',
  templateUrl: './delete-batch-table.component.html',
  styleUrls: ['./delete-batch-table.component.scss']
})
export class DeleteBatchTableComponent implements OnInit {
  totalRecords: number = 8;

  constructor(public batchAlertService: BatchAlertService,
    public dialog: MatDialog,
    public rootService: RootScopeService) { }

  ngOnInit(): void {
  }

  /* istanbul ignore next */
  rowSelection(data) {
  }

 
}
